import { render, staticRenderFns } from "./TeaIntro.vue?vue&type=template&id=3e35d1b7&scoped=true&"
import script from "./TeaIntro.vue?vue&type=script&lang=js&"
export * from "./TeaIntro.vue?vue&type=script&lang=js&"
import style0 from "./TeaIntro.vue?vue&type=style&index=0&id=3e35d1b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e35d1b7",
  null
  
)

export default component.exports